import type { ComputedRef, InjectionKey, Ref } from 'vue'

export type WorkbenchUiContext = {
    /** PC workbench compact-on-scroll state */
    isCompact: Ref<boolean>
    /** Left creator panel collapsed state (true=collapsed, false=expanded) */
    creatorPanelCollapsed?: ComputedRef<boolean> | Ref<boolean>
}

export const workbenchUiKey: InjectionKey<WorkbenchUiContext> = Symbol('workbenchUi')

